<template>
<div>
    <div class="ml-4 rounded  border w-2/5 pb-8 md:w-full md:border-0">
        <div class="w-4/5 m-auto pt-8 md:w-full">
            <p class="text-blue-700">Pricing</p>
            <p class="text-gray-500 text-sm ">Change pricing per kilometer</p>

            <div class="mt-10">
                <div>
                    <label for="package" class="text-blue-700">Select Package</label>
                    <select name="package" id="package" class="border-2 w-full rounded-lg p-3 text-sm" @change="selectedPackage($event)">
                        <option selected value="" disabled>Select a Service</option>
                        <option  value="haulage">Haulage</option>
                        <option value="buyForMe">Buy For Me</option>
                        <option value="bookARide">Book A Ride</option>
                        <option value="sendAPackage">Send a Package</option>
                    </select>
                     <p v-if="packageValidity === 'invalid'" class=" text-xs text-red-500">This field cannot be empty.</p>
                </div>
                <div v-if="currentPrice <= 0" class="mt-6">
                    <label for="set-pricing" class="text-blue-700">Set Price</label><br>
                    <input class="border-2 w-full rounded-lg p-3 text-sm mt-3" type="text" name="set-pricing" id="set-pricing" v-model="setPrice">
                    <p v-if="setPriceValidity === 'invalid'" class=" text-xs text-red-500">This field cannot be empty.</p>
                    <div class="mt-10 flex">
                    <button @click="setAPrice" class="p-3 text-white rounded-lg" style="background-color:#0048AE"> Set Pricing</button>
                    <p v-if="isLoading" class="ml-2 mt-2 animate-spin rounded-full h-6 w-6 border border-t-2 border-b-2 border-blue-900 "></p>
                </div>
                </div>
                <div v-if="currentPrice > 0" class="mt-6">
                    <label for="current-pricing" class="text-blue-700">Current Pricing (Per KM)</label><br>
                    <input class="border-2 w-full rounded-lg p-3 text-sm mt-3" type="text" name="current-pricing" id="current-pricing" :value="currentPrice" disabled>
                    <p v-if="currentPriceValidity === 'invalid'" class=" text-xs text-red-500">This field cannot be empty.</p>
                </div>
                <div v-if="currentPrice > 0" class="mt-4">
                    <div class="mt-6">
                        <label for="new-pricing" class="text-blue-700">Update Pricing</label><br>
                        <input class="border-2 mt-3 w-full rounded-lg p-3 text-sm" type="text" name="new-pricing" id="new-pricing" placeholder="New Pricing" v-model="newPrice">
                        <p v-if="newPriceValidity === 'invalid'" class=" text-xs text-red-500">This field cannot be empty.</p>
                    </div>
                    <div class="mt-10 flex">
                        <button @click="updatePrice()" class="p-3 text-white rounded-lg" style="background-color:#0048AE">Update Pricing</button>
                        <p v-if="isLoading" class="ml-2 mt-2 animate-spin rounded-full h-6 w-6 border border-t-2 border-b-2 border-blue-900 "></p>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
    <SuccessfulModal
    v-show="successModal"
    @click="closeSuccessModal"
    :message="message"
    />
    <ErrorModal
    v-show="errorModal"
    @click="closeErrorModal"
    :message="message"
    />
</div>
</template>

<script>
import axios from 'axios';
import SuccessfulModal from '../../LandingPages/SuccessfulModal.vue';
import ErrorModal from '../ErrorModal.vue';
import {baseUrl} from '../../../Config';
const url = baseUrl;
export default {
    components: {
        SuccessfulModal,
        ErrorModal
    },
    data() {
        return {
            userId: localStorage.getItem('userId'),
            currentPrice:"",
            newPrice:"",
            newPriceValidity: "",
            currentPriceValidity: "",
            isLoading:false,
            errorModal: false,
            successModal: false,
            message: "",
            package:"",
            setPrice: "",
            packageValidity: "",
            setPriceValidity : "",
            pricePerKm: [],
            token : localStorage.getItem("token")
        }
    },

    mounted() {
        this._getCurrentPrice();
        this.getPricePerKm();
    },
    methods: {
        closeSuccessModal() {
            this.successModal = false;
            this._getCurrentPrice();
        },
        closeErrorModal() {
            this.errorModal = false
        },
        selectedPackage(event) {
            this.package = event.target.value;
            for(let i =  0; i < this.pricePerKm.length; i++) {
                if(this.package === "buyForMe" && this.pricePerKm[i].packageType === "buyForMe") {
                    this.currentPrice = this.pricePerKm[i].pricePerKm
                    // this.currentPrice = ""
                }
                 if(this.package === "haulage" && this.pricePerKm[i].packageType === "haulage") {
                    this.currentPrice = this.pricePerKm[i].pricePerKm
                }
                if(this.package === "sendAPackage" && this.pricePerKm[i].packageType === "sendAPackage") {
                    this.currentPrice = this.pricePerKm[i].pricePerKm
                }
                if(this.package === "bookARide" && this.pricePerKm[i].packageType === "bookARide") {
                    this.currentPrice = this.pricePerKm[i].pricePerKm
                }
            }
                       
        },
        _getCurrentPrice() {
            axios({
                method: 'GET',
                url: `${url}/v1/web/users/config/price/${this.userId}`,
                headers: {
                    'Content-type': 'application/json',
                    authorization: `Bearer ${this.token}`,
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                }
            })
            .then((res) => {
                let current = res.data.data.pricePerKm;
                this.currentPrice = current.toLocaleString();
            })
            .catch((err) => {
                let message = err.response.data.message;
                    if(err) {
                        this.errorModal = true;
                        this.message = message
                    }
                    this.isLoading = false;
            })
        },

        updatePrice() {
            if(!this.package) {
                this.packageValidity = 'invalid';
            } else if (!this.newPrice) {
                this.newPriceValidity = 'invalid';
            } else {
                this.isLoading = true
                axios({
                method: 'PUT',
                url: `${url}/v1/web/users/config/price/${this.userId}`,
                headers: {
                    'Content-type': 'application/json',
                    authorization: `Bearer ${this.token}`,
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
                data : {
                    pricePerKm: this.newPrice,
                    packageType: this.package
                }
                })
                .then((res) =>{
                    res.json;
                    this.successModal = true;
                    this.isLoading = false;
                    this.newPrice = "";
                })
                .catch((err)=>{
                    let message = err.response.data.message;
                    if(err) {
                        this.errorModal = true;
                        this.message = message
                    }
                    this.isLoading = false;
                })
            }
            
        },

        setAPrice() {
            if (!this.package) {
                this.packageValidity = 'invalid';
            } else if(!this.setPrice){
                this.setPriceValidity = 'invalid';
            } else {
                this.isLoading = true
                axios({
                method: 'PUT',
                url: `${url}/v1/web/users/config/price/${this.userId}`,
                headers: {
                    'Content-type': 'application/json',
                    authorization: `Bearer ${this.token}`,
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
                data : {
                    pricePerKm: this.setPrice,
                    packageType: this.package
                }
                })
                .then((res) =>{
                    res.json;
                    this.successModal = true;
                    this.isLoading = false;
                    this.setPrice = "";
                    this.package= "";
                })
                .catch((err)=>{
                    let message = err.response.data.message;
                    if(err) {
                        this.errorModal = true;
                        this.message = message
                    }
                    this.isLoading = false;
                })
            }
            
        },

        getPricePerKm() {
            axios({
                method: 'GET',
                url: `${url}/v1/web/users/config/price/${this.userId}`,
                headers: {
                    'Content-type': 'application/json',
                    authorization: `Bearer ${this.token}`,
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                }
            })
            .then((res) => {
                this.pricePerKm = res.data.data
            })
            .catch((err) => {
                let message = err.response.data.message;
                    if(err) {
                        this.errorModal = true;
                        this.message = message
                    }
                    this.isLoading = false;
            })
        }
    }
}
</script>